import PropTypes from 'prop-types';

export const propTypes = {
  deeplinkIntoReservationFlow: PropTypes.func,
};
